module.exports = __webpack_public_path__ + "img/error.bb35d17d.png";